import React, { useState } from 'react';
import type { Project } from '../../../hooks/queries/projectTypes';
import { useProjectUIStore } from '../../../store/projectUIStore';
import { ArchivedWelcomeScreen } from './ArchivedWelcomeScreen';
import { ActiveWelcomeScreen } from './ActiveWelcomeScreen';

interface WelcomeScreenProps {
  hasProjects: boolean;
  latestProject?: Project;
  onProjectSelect?: (projectId: string) => void;
  user: any;
  navigate: any;
  loading: boolean;
}

export function WelcomeScreen({
  hasProjects,
  latestProject,
  onProjectSelect,
  user,
  navigate,
  loading,
}: WelcomeScreenProps) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { showArchived } = useProjectUIStore();

  if (showArchived) {
    return (
      <ArchivedWelcomeScreen
        isMobileMenuOpen={isMobileMenuOpen}
        setIsMobileMenuOpen={setIsMobileMenuOpen}
        onProjectSelect={onProjectSelect}
        loading={loading}
        user={user}
        navigate={navigate}
      />
    );
  }

  return (
    <ActiveWelcomeScreen
      hasProjects={hasProjects}
      latestProject={latestProject}
      isMobileMenuOpen={isMobileMenuOpen}
      setIsMobileMenuOpen={setIsMobileMenuOpen}
      onProjectSelect={onProjectSelect}
      loading={loading}
      user={user}
      navigate={navigate}
    />
  );
}
